export const PROJECT_LIST_SIDE_GUTTER = 8;

export const PROJECT_LIST_ROW_HEIGHT = 48;

export const PROJECT_MAP_CARD_HEIGHT = 116;

export const PROJECT_MAP_CARD_GAP = 4;

export const PROJECT_SELECTED_BACKGROUND = 'rgba(250,250,247,0.5)';
export const PROJECT_SELECTED_SHADOW = '0 8px 40px rgba(0,0,0,0.08)';
export const PROJECT_SURFACE_RADIUS = '7px';

export const PROJECT_HOVER_BACKGROUND = 'rgba(0,0,0,0.05)';
